import { useState } from 'react'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import MuiLink from '@mui/material/Link'
import useSetPlaces from '../models/useSetPlaces'
import useOrganizations from '../models/useOrganizations'
import useAuth from '../models/useAuth'
import { presumeController } from '../utilities/nodeAccess'
import { ResetPlaceDialog } from './PlaceDialogs'

/**
 * On a node's page, under its place: the place was set by hand (nobgp-router#1976), where its
 * address is, and, for the node's controllers, a way to put it back there.
 */
export default function NodeSetPlace({
  node,
  addressPlace,
}: {
  node: { id: string; ownerUserId?: string | null; ownerOrgId?: string | null }
  /** The place of the node's address (GeoLite data), or null when there is none. */
  addressPlace: string | null
}) {
  const organizations = useOrganizations(s => s.organizations)
  const selfId = useAuth(s => s.user?.id)
  const [open, setOpen] = useState(false)
  const controls = presumeController(organizations, node, selfId)
  return (
    <Typography variant="caption" component="span" sx={{ color: 'text.secondary' }}>
      Placed by hand.
      {/* ⚠ The place of the address is GeoLite data, so its credit goes with it (nobgp/nobgp-router#1934). */}
      {addressPlace && (
        <>
          {' '}
          Its address is in {addressPlace} (location data by{' '}
          <MuiLink href="https://www.maxmind.com" target="_blank" rel="noreferrer" color="inherit">
            MaxMind
          </MuiLink>
          ).
        </>
      )}
      {controls && (
        <Button size="small" variant="text" sx={{ ml: 1, minWidth: 0, p: 0, verticalAlign: 'baseline' }} onClick={() => setOpen(true)}>
          Put back
        </Button>
      )}
      {open && (
        <ResetPlaceDialog
          reset={{ nodeIds: [node.id], label: 'this node' }}
          onCancel={() => setOpen(false)}
          onConfirm={async () => {
            const refused = await useSetPlaces.getState().clearNodes([node.id])
            if (refused.length) return 'It could not be put back. Try again.'
            setOpen(false)
            return null
          }}
        />
      )}
    </Typography>
  )
}
